export const GoldDropMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="12" fill="#FFFFFF" stroke="#F5B800" strokeWidth="2.5" />
    <path d="M27.5 7 14 27h8.5L20 41 34 20h-9l2.5-13Z" fill="url(#gd-gold)" />
    <defs>
      <linearGradient id="gd-gold" x1="14" y1="7" x2="34" y2="41" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF4D4D" />
        <stop offset="1" stopColor="#CC0000" />
      </linearGradient>
    </defs>
  </svg>
);

export const LogoLockup = () => (
  <a href="#top" data-testid="brand-logo" className="font-display text-lg font-extrabold tracking-tight text-slate-900">
    FXTM Africa
  </a>
);
